import { selectEvents as e } from "./selectors/index.js";
import { useDatePickerStore as t } from "./use-date-picker-store.js";
import n from "react";
import { Fragment as r, jsx as i } from "react/jsx-runtime";
// src/design/forms/datepicker/core/models/props-syncer.tsx
var a = n.memo((a) => {
	let o = t((e) => e), { syncProps: s } = e(o);
	return n.useEffect(() => {
		s(a);
	}, [a]), /* @__PURE__ */ i(r, {});
}, (e, t) => JSON.stringify(e) === JSON.stringify(t));
export { a as PropsSyncer };

//# sourceMappingURL=props-syncer.js.map